import * as log from '../../../utils/log';
import { updateIsAutheticatedUI, updateIsLoading, updatePayload, updateTrustScoreAction, updateTrustscoreRetryCount } from '../../store/actions/index';
import store from '../../store/index';
function TrustScoreFormSession(formId, payload) {
    log.info('TrustScoreFormSession::setAvailableTargets', {
        formId: formId,
        payload: payload
    }, 'component');
    store.dispatch(updatePayload(payload));
    var createUi = function () {
        log.info('TrustScoreFormSession::createUi', '', 'component');
        store.dispatch(updateIsAutheticatedUI(true));
    };
    var startSession = function (clientContext, actionContext) {
        log.info('TrustScoreFormSession::startSession', {
            clientContext: clientContext,
            actionContext: actionContext
        }, 'component');
        store.dispatch(updateIsLoading(false));
        createUi();
    };
    var promiseFormInput = function () {
        log.info('formSession::promiseFormInput', '', 'component');
        return new Promise(function (resolve) {
            var unsubscribe = store.subscribe(function () {
                var _a = store.getState(), trustScoreAction = _a.trustScoreAction, trustscoreRetryCount = _a.trustscoreRetryCount;
                if (trustScoreAction === 'submit') {
                    unsubscribe();
                    store.dispatch(updateTrustScoreAction(null));
                    store.dispatch(updateTrustscoreRetryCount(trustscoreRetryCount + 1));
                    store.dispatch(updateIsLoading(true));
                    resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                        action: 'continue',
                        phone_number: store.getState().phoneNumber,
                        count: store.getState().trustscoreRetryCount
                    }));
                }
                if (trustScoreAction === 'cancel') {
                    unsubscribe();
                    store.dispatch(updateTrustScoreAction(null));
                    store.dispatch(updateIsLoading(true));
                    resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                        action: 'cancel'
                    }));
                }
                if (trustScoreAction === 'alternate') {
                    unsubscribe();
                    store.dispatch(updateTrustScoreAction(null));
                    store.dispatch(updateIsLoading(true));
                    resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                        action: 'alternateFlow'
                    }));
                }
            });
        });
    };
    var endSession = function () {
        log.info('formSession::endSession', '', 'component');
        store.dispatch(updateIsAutheticatedUI(false));
    };
    return {
        startSession: startSession,
        promiseFormInput: promiseFormInput,
        endSession: endSession,
        createUi: createUi
    };
}
export default TrustScoreFormSession;
